import React, {Component} from 'react';
import './SearchBox.css';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import actions from './search.actions';
import SearchUserTypeSelector from './SearchUserTypeSelector';

export class SearchBox extends Component {
	constructor() {
		super();

		this.state = {
			redirect: false,
			searchFocused: false
		};

		this.startSearch = e => {
			if (!this.props.query) {
				// Disallow search if no query entered
				e.preventDefault();
				return;
			} else {
				this.props.setSearchFor('provider'); // If user hits enter/search button, it should search for providers by default
			}
		};

		this.handleKeyPress = event => {
			if (event.key === 'Enter') {
				this.props.setSearchFor('provider'); // If user hits enter/search button, it should search for providers by default
				this.setState({redirect: true});
			}
		};

		this.setSearchProvider = () => {
			this.props.setSearchFor('provider');
			this.setState({redirect: true});
		};
		this.setSearchCommunity = () => {
			this.props.setSearchFor('community');
			this.setState({redirect: true});
		};
		this.setSearchUser = () => {
			this.props.setSearchFor('user');
			this.setState({redirect: true});
		};
		this.setSearchFocus = () => {
			this.setState({searchFocused: true});
		};
		this.setSearchBlur = () => {
			// Delayed blur to allow for clicking in dropdown
			setTimeout(() => this.setState({searchFocused: false}), 200);
		};
	}

	componentDidUpdate() {
		if (this.state.redirect) {
			this.setState({redirect: false}); // Redirect should only execute once
		}
	}

	render() {
		const {query, setQuery, compact, className} = this.props;

		return (
			<div className={`SearchBox ${className || ''} ${compact ? 'compact' : ''}`}>
				{this.state.redirect && <Redirect push to={`/search/${query || ''}`} />}
				<div
					className={`SearchBox-search ${
						this.state.searchFocused && query && query.length ? 'dropped' : ''
					}`}>
					<input
						type="search"
						placeholder="Search by name, type, location, ..."
						value={query}
						onFocus={this.setSearchFocus}
						onBlur={this.setSearchBlur}
						onChange={setQuery}
						onKeyPress={this.handleKeyPress}
					/>
					{/* <Link onClick={this.startSearch} to={`/search/${query || ''}`}><span className="icon-search"></span></Link> */}
					<div className="SearchBox-dropdown">
						<SearchUserTypeSelector
							// invert={true}
							compact={false}
							setSearchProvider={this.setSearchProvider}
							setSearchCommunity={this.setSearchCommunity}
							setSearchUser={this.setSearchUser}
							radii={true}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const ConnectedSearchBox = connect(
	state => ({
		query: state.search.query,
		searchFor: state.search.searchFor
	}),
	dispatch => ({
		setQuery: e => dispatch(actions.searchSetQuery(e.target.value)),
		setSearchFor: searchFor => {
			dispatch(actions.searchFor(searchFor));
			dispatch(actions.performSearch());
		}
	})
)(SearchBox);

export default ConnectedSearchBox;



// WEBPACK FOOTER //
// ./src/search/SearchBox.js